import React from 'react'
import MainNavigation from '@toasttab/shared/src/components/organisms/Navigation/MainNavigation'
import { getMainNavigationMenu } from '@toasttab/shared/src/data/HeaderNavigation/getMainNavigationMenu'
import {
  prependHostName,
  JSONValue
} from '@toasttab/shared/src/utils/siteUtils'
import { NavControllerProps } from '@toasttab/shared/src/interfaces/Navigation'
import {
  PricingCA,
  ProductsCA,
  ResourcesCA,
  RestaurantTypesCA
} from '@toasttab/shared/src/data/HeaderNavigation/menus/ca'
import {
  PricingIE,
  ProductsIE,
  ResourcesIE,
  RestaurantTypesIE
} from '@toasttab/shared/src/data/HeaderNavigation/menus/ie'
import {
  PricingUK,
  ProductsUK,
  ResourcesUK,
  RestaurantTypesUK
} from '@toasttab/shared/src/data/HeaderNavigation/menus/uk'
import {
  PricingUS,
  ProductsUS,
  ResourcesUS,
  RestaurantTypesUS,
  RetailUS
} from '@toasttab/shared/src/data/HeaderNavigation/menus/us'
import {
  ParentMenuProps,
  SiteRegionTypes
} from '@toasttab/shared/src/data/HeaderNavigation/MainNavigationMenu'

const NavController = ({
  mobileSalesIndicatorSchedule = null,
  packageName,
  siteId,
  siteMetadata
}: NavControllerProps) => {
  let parentMenus: ParentMenuProps[]
  let siteRegion: SiteRegionTypes
  switch (siteId) {
    case 2:
      parentMenus = [ProductsUK, PricingUK, RestaurantTypesUK, ResourcesUK]
      siteRegion = 'uk'
      break
    case 3:
      parentMenus = [ProductsIE, PricingIE, RestaurantTypesIE, ResourcesIE]
      siteRegion = 'ie'
      break
    case 4:
      parentMenus = [ProductsCA, PricingCA, RestaurantTypesCA, ResourcesCA]
      siteRegion = 'ca'
      break
    case 1:
    default:
      parentMenus = [
        RestaurantTypesUS,
        RetailUS,
        ProductsUS,
        PricingUS,
        ResourcesUS
      ] // RetailUS array Item - Retail Nav Dropdow Test - CRO-RETAILNAV-DROP
      siteRegion = 'us'
      break
  }
  // Prepend https://pos.toasttab.com for support.toasttab.com
  const mainNavMenu =
    packageName === 'support'
      ? prependHostName(
          getMainNavigationMenu(
            parentMenus,
            siteRegion
          ) as unknown as JSONValue,
          siteMetadata.siteUrl
        )
      : getMainNavigationMenu(parentMenus, siteRegion)

  return (
    <MainNavigation
      mobileSalesIndicatorSchedule={mobileSalesIndicatorSchedule}
      navigationData={mainNavMenu}
      siteRegion={siteRegion}
    />
  )
}

export default NavController
